import React, { FC, ReactNode } from 'react';

import { Text, TextProps } from '@yandex-360/orb-components/dist/components/Text';

import css from './styles.css';

export interface HeadingProps extends Pick<TextProps, 'typography' | 'color'> {
    title: string;
    subtitle?: string;
    rightCustom?: ReactNode;
}

export const Heading: FC<HeadingProps> = ({ title, typography = 'heading-xs', color, subtitle, rightCustom }) => {
    return (
        <div className={css.wrapper} data-testid="heading">
            <div className={css.titleWrapper}>
                <Text testId="title" as="h3" className={css.title} typography={typography} color={color}>
                    {title}
                </Text>
                {rightCustom && <>{rightCustom}</>}
            </div>

            {subtitle && (
                <Text testId="subtitle" typography="body-short-md-regular" color="secondary">
                    {subtitle}
                </Text>
            )}
        </div>
    );
};
